<template lang="pug">
div
  timeago(:datetime="datetime",
          v-if="shouldShowTime",
          :autoUpdate="autoUpdate",
          :converter="converter")
</template>

<script>
import moment from 'moment';
import {
  formatDistanceToNow,
  formatDistanceToNowStrict,
} from "date-fns";

export default {
  name: 'aiqTimeago',
  props: {
    since: {
      type: String,
      required: true,
    },
    autoUpdate: {
      type: Number,
      default: 30,
    },
    maxTime: {
      type: Number,
      default: 60 * 60 * 3, // 3 hours
    },
    minTime: {
      type: Number,
      default: 60, // 1 minute
    },
    format: {
      type: Function,
      default(time) {
        return moment().isSame(moment(time), 'day')
          ? moment(time).calendar()
          : moment(time).format('lll');
      },
    },
  },
  computed: {
    datetime() {
      return Date.parse(this.since);
    },
  },
  data() {
    return {
      shouldShowTime: false,
      timeoutRef: null,
    };
  },
  watch: {
    maxTime() {
      this.updateTimeAgo();
    },
  },
  methods: {
    updateTimeAgo() {
      this.shouldShowTime = false;
      this.$nextTick(() => this.shouldShowTime = this.canShowTime());
    },
    canShowTime() {
      return this.since
        && moment(Date.parse(this.since))
          .isBefore(moment()
            .subtract(this.minTime, 'seconds')
            .toISOString());
    },
    converter(datetime, converterOptions, locale) {
      const diff = moment().diff(moment(datetime));
      const diffSeconds = moment.duration(diff).asSeconds();
      if (diffSeconds > this.maxTime) {
        return this.format(datetime);
      }
      return this.defaultConverter(datetime, converterOptions, locale);
    },
    defaultConverter(datetime, options = {}, locale) {
      if (options.useStrict) {
        return formatDistanceToNowStrict(datetime, {
          addSuffix: options.addSuffix ?? true,
          locale,
          unit: options.unit,
          roundingMethod: options.roundingMethod,
        });
      }

      return formatDistanceToNow(datetime, {
        includeSeconds: options.includeSeconds,
        addSuffix: options.addSuffix ?? true,
        locale,
      });
    },
  },
  mounted() {
    this.shouldShowTime = this.canShowTime();
    if (this.shouldShowTime) {
      return;
    }
    this.timeoutRef = setTimeout(() => {
      this.shouldShowTime = this.canShowTime();
    }, this.minTime * 1000);
  },
  beforeUnmount() {
    clearTimeout(this.timeoutRef);
  },
};
</script>
